import Header from '../components/layout/Header'
import Footer from '../components/layout/Footer'
import Layout from '../components/layout/Layout';

const NotFoundPage = () => {

    return (
        <Layout>
            <Header />

            <section className="my-10 flex flex-col grow justify-center items-center">
                <section className="w-96 h-72 flex flex-col gap-5 justify-center items-center bg-gray-100 rounded-xl ">

                    <h2>404 | This page could not be found</h2>

                    <div>
                        <a href="/" className="bg-emerald-300 transition-all border border-emerald-300 px-3 md:px-4 py-2 h-full rounded-lg hover:shadow font-bold">
                            Go Home
                        </a>
                    </div>

                </section>
            </section>

            <Footer />
        </Layout>
    )
}

export default NotFoundPage;
